function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1,.prefix__cls-2{fill:none;stroke:#66cb35;stroke-width:.75px}.prefix__cls-1{stroke-linejoin:round}.prefix__cls-2{stroke-linecap:round;stroke-miterlimit:10}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_37",
  "data-name": "Group 37",
  transform: "translate(-50.455 -262.848)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_11",
  d: "M0 0L6.621 0",
  className: "prefix__cls-1",
  "data-name": "Line 11",
  transform: "translate(51.53 265.584)"
}), /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_33",
  "data-name": "Group 33",
  transform: "translate(50.83 263.223)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_24",
  d: "M57.534 268.081h.853a.464.464 0 0 1 .463.463v6.37a.466.466 0 0 1-.463.465h-7.094a.466.466 0 0 1-.463-.465v-6.37a.465.465 0 0 1 .463-.463h1.274",
  className: "prefix__cls-1",
  "data-name": "Path 24",
  transform: "translate(-50.83 -267.362)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_12",
  d: "M0 0L1.109 0",
  className: "prefix__cls-1",
  "data-name": "Line 12",
  transform: "translate(4.678 .719)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_13",
  d: "M0 0L1.109 0",
  className: "prefix__cls-1",
  "data-name": "Line 13",
  transform: "translate(2.653 .719)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_14",
  d: "M0 0L0 1.574",
  className: "prefix__cls-2",
  "data-name": "Line 14",
  transform: "translate(1.769)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_15",
  d: "M0 0L0 1.574",
  className: "prefix__cls-2",
  "data-name": "Line 15",
  transform: "translate(5.819)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_16",
  d: "M0 0L0 1.574",
  className: "prefix__cls-2",
  "data-name": "Line 16",
  transform: "translate(3.794)"
})), /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_36",
  "data-name": "Group 36",
  transform: "translate(52.12 266.478)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_34",
  "data-name": "Group 34",
  transform: "translate(0 1.198)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_17",
  d: "M0 0L5.44 0",
  className: "prefix__cls-1",
  "data-name": "Line 17"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_18",
  d: "M0 0L5.44 0",
  className: "prefix__cls-1",
  "data-name": "Line 18",
  transform: "translate(0 1.516)"
})), /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_35",
  "data-name": "Group 35",
  transform: "translate(1.204)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_19",
  d: "M0 3.911L0 0",
  className: "prefix__cls-1",
  "data-name": "Line 19",
  transform: "translate(1.516)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_20",
  d: "M0 3.911L0 0",
  className: "prefix__cls-1",
  "data-name": "Line 20"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_21",
  d: "M0 3.911L0 0",
  className: "prefix__cls-1",
  "data-name": "Line 21",
  transform: "translate(3.032)"
}))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.77,
    height: 8.767,
    viewBox: "0 0 8.77 8.767",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.52bc917f.svg";
export { ForwardRef as ReactComponent };